import React, {useEffect} from "react";
import {ConfirmDialog} from "primereact/confirmdialog";
import {Message} from "primereact/message";
import {ProgressSpinner} from "primereact/progressspinner";
import {useSelector} from "react-redux";
import AdminAccessDenied from "../../system/components/admin-access-denied";
import {CONTENT_TYPE_UIDS} from "../../system/content-type-registry";
import {hasAdminRoleAccess} from "../../system/admin-access";
import {useContentTypeData} from "../../system/use-content-type-data";
import {useTranslate} from "../../system/useTranslate";
import CreatePost from "./create-post";
import PostCategoryManager from "./post-category-manager";

export const POST_MANAGEMENT_ROLES = ["Author", "Editor"];

const CATEGORIES_QUERY = {
    sort: "order:ASC",
};

function PostsContent() {
    const translate = useTranslate();
    const categories = useContentTypeData(CONTENT_TYPE_UIDS.POST_CATEGORY);

    useEffect(() => {
        categories.ensure(CATEGORIES_QUERY, {all: true}).catch(() => undefined);
        // The collection methods are stable for this UID.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (categories.loading && categories.items.length === 0) {
        return (
            <div className="w-full h-full flex align-items-center justify-content-center">
                <ProgressSpinner/>
            </div>
        );
    }

    if (categories.error && categories.items.length === 0) {
        return (
            <div className="p-3">
                <Message className="w-full text-xs" severity="error" text={translate("post-categories-load-failed")}/>
            </div>
        );
    }

    return (
        <div className="h-full w-full flex overflow-hidden rtl">
            <div className="flex-1 min-w-0 overflow-auto">
                <CreatePost postCategories={categories.items}/>
            </div>
            <aside className="w-24rem flex-none border-left-1 border-300 surface-50 overflow-auto p-3">
                <PostCategoryManager categoriesCollection={categories}/>
            </aside>
            <ConfirmDialog acceptClassName="text-xs" rejectClassName="text-xs p-button-text" className="rtl"/>
        </div>
    );
}

function Posts() {
    const {user} = useSelector((state) => state.auth);

    if (!hasAdminRoleAccess(user, POST_MANAGEMENT_ROLES)) {
        return (
            <AdminAccessDenied
                titleKey="posts-access-denied-title"
                descriptionKey="posts-access-denied-description"
            />
        );
    }

    return <PostsContent/>;
}

export default Posts;
